// Manage FullStory library already loaded in the page through google tag manager

// Note: Fullstory initializes for all users just by importing the module.
// The only method in use here is identifying a user once we know who they are. It
// will still gather data for anon users.

import { initParams } from "../../types/fullstory";

// Declare the FS function that's defined in the FullStory library
declare function FS(command: string, params?: any): void;

const FullStory = {
  identifyUser: ({ uid, data }: initParams) => {
    if (document.readyState === "complete") {
      FullStory.setIdentity(uid, data);
    }
  },
  setIdentity: (uid: string, properties: any) => {
    FS("setIdentity", {
      uid,
      properties,
    });
  },
  event: (eventName: string, data: {}) => {
    // Commented out to avoid sending events twice to FullStory (once via GA4 and once via this function)
    // By commenting this out here, we ensure mobile behaviour is not impacted
    // FS("trackEvent", {
    //   name: eventName,
    //   properties: data,
    // });
  },
};

export default FullStory;
